import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ROOT, DeviceIdService } from '../device-id.service';

/**
 * Manda el id de dispositivo confiable en cada request a la API.
 *
 * El gateway revalida la confianza del device en cada llamada, no sólo en el login: sin el
 * header, un usuario autenticado recibe un 403 con `X-2FA-Required: true` mientras navega,
 * aunque el login haya salido bien.
 *
 * Va en su propio interceptor y no dentro de `AuthInterceptorService` porque ése corta las
 * requests marcadas con `noCheckToken` (login, refresh) antes de su lógica de headers — y
 * ésas son justo las llamadas que necesitan el device id.
 */
@Injectable()
export class DeviceIdInterceptor implements HttpInterceptor {
  constructor(private deviceIdService: DeviceIdService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(API_ROOT)) {
      return next.handle(request);
    }

    const deviceId = this.deviceIdService.get();
    if (!deviceId) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: { [DeviceIdService.HEADER]: deviceId },
      }),
    );
  }
}
